"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BusyIndicator = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _react = _interopRequireWildcard(require("react"));
var _focusManager = require("../utils/focusManager");
var _useAnnouncedMessage = require("../utils/_useAnnouncedMessage");
var _useUniqueId = require("../utils/useUniqueId");
var _useUniversalLayoutEffect = _interopRequireDefault(require("../utils/useUniversalLayoutEffect"));
var _BusyIndicator = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./BusyIndicator.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-busy-indicator';
/**
 * The **BusyIndicator** component provides feedback to a user during the loading of
 * another component or page.
 *
 * In order for this component to be used with the included mask, it must be
 * placed inside an HTML element that is relatively positioned unless it's using
 * the `fullScreen` type. The `cnqr-position-relative` CSS class can be used to set
 * relative positioning on any element. For example, the **BusyIndicator** might
 * be inside an application’s parent HTML container or inside a section on the page.
 *
 * > When using either the default or full-screen **BusyIndicator**, the component
 * will add an `inert` attribute to the nearest relatively-positioned parent element
 * or the `document.body`. This attribute is added to make content invisible to the
 * accessibility tree. If the component is adding the `inert` attribute to the wrong
 * element, consumers can pass the element that should be used (using the `inertContainer`
 * property). By using the `inert` attribute, keyboard navigation and speech output
 * will be disabled to underlying elements while **BusyIndicator** is active and will
 * avoid confusion to sight-impaired users and keyboard navigation users that
 * inaccessible/invisible elements are present on the page.
 *
 *
 * > If `inertContainer` is not set, `document.body` will be made `inert` which will
 * prevent screen-readers from announcing the **BusyIndicator** message.
 * Hence it is highly recommended to set `inertContainer` when showing a
 * full-screen **BusyIndicator** with text message.
 *
 * See the [Busy State](./?path=/docs/patterns-busy-state--docs)
 * patterns page for more usage examples.
 */
var BusyIndicator = exports.BusyIndicator = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var boxProps = props.boxProps,
    statusProps = props.statusProps,
    className = props.className,
    id = props.id,
    inertContainer = props.inertContainer,
    message = props.message,
    messageProps = props.messageProps,
    messageContainerProps = props.messageContainerProps,
    size = props.size,
    type = props.type,
    visible = props.visible,
    showMessage = props.showMessage,
    customBody = props.customBody,
    overflow = props.overflow,
    isScrollingContainer = props.isScrollingContainer,
    otherProps = __rest(props, ["boxProps", "statusProps", "className", "id", "inertContainer", "message", "messageProps", "messageContainerProps", "size", "type", "visible", "showMessage", "customBody", "overflow", "isScrollingContainer"]);
  var classnames = _bind.default.bind(_BusyIndicator.default);
  var uniqueId = (0, _useUniqueId.useUniqueId)();
  if (id) {
    uniqueId = id;
  }
  var isDefault = typeof type === 'undefined' || type === 'fullPage';
  var isSmallDefault = isDefault && size === 'sm';
  var isFullScreen = type === 'fullScreen';
  var isInline = type === 'inline';
  var isBlock = type === 'block';
  var focusManagerRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);
  var inertContainerRef = (0, _react.useRef)(null);
  var activeElementRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  (0, _react.useEffect)(function () {
    setIsMounted(true);
  }, []);
  /**
   * Note: JAWS requires an element with `role="status"` to be initially rendered on the page,
   * and then dynamically update its content in order for it to be announced.
   */
  var announcedMessage = (0, _useAnnouncedMessage.useAnnouncedMessage)({
    announce: isFullScreen,
    message: message,
    disableReset: true
  }, [visible, message, isFullScreen]);
  (0, _useUniversalLayoutEffect.default)(function () {
    var _a, _b;
    // inline and block types do not require setting the 'inert' attribute
    if (isInline || isBlock) return function () {};
    // if a previous inert element existed, clear that before proceeding
    if (inertContainerRef.current) {
      inertContainerRef.current.removeAttribute('inert');
      inertContainerRef.current.style.overflow = overflow || '';
    }
    var inertElement;
    // if the consumer passed an 'inertContainer', just use that
    if (inertContainer) {
      inertElement = inertContainer;
    } else {
      // fullscreen should just use document.body so we will skip this step
      // and let it get set as the fallback below
      if (!isFullScreen) {
        inertElement = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetParent;
      }
      if (!inertElement) {
        inertElement = document.body;
      }
    }
    if (inertElement) {
      inertContainerRef.current = inertElement;
      if (visible) {
        if (inertElement.contains(document.activeElement)) {
          activeElementRef.current = document.activeElement;
        }
        inertElement.setAttribute('inert', 'true');
        inertElement.style.overflow = 'hidden';
      } else {
        inertElement.removeAttribute('inert');
        inertElement.style.overflow = overflow || '';
        if (!document.activeElement || document.activeElement === document.body) {
          (_b = activeElementRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        activeElementRef.current = null;
      }
    }
    if (isScrollingContainer && containerRef.current && inertContainerRef.current) {
      // if the container is a scrolling container, we need to adjust the top position
      // of the mask to match the scroll position of the container
      containerRef.current.style.top = "".concat(inertContainerRef.current.scrollTop, "px");
    }
    return function () {
      var _a;
      inertElement.removeAttribute('inert');
      inertElement.style.overflow = overflow || '';
      if (!document.activeElement || document.activeElement === document.body) {
        (_a = activeElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      }
      activeElementRef.current = null;
    };
  }, [visible, inertContainer]);
  var _handleFocusManager = function _handleFocusManager(node) {
    if (isFullScreen && visible && node) {
      focusManagerRef.current = new _focusManager.FocusManager({
        trapNode: node
      });
    }
  };
  var _renderBusyIndicator = function _renderBusyIndicator() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(CSS_BLOCK, "__progress"))
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(CSS_BLOCK, "__circle"), "".concat(CSS_BLOCK, "__circle--0"))
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(CSS_BLOCK, "__circle"), "".concat(CSS_BLOCK, "__circle--1"))
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classnames("".concat(CSS_BLOCK, "__circle"), "".concat(CSS_BLOCK, "__circle--2"))
    }));
  };
  var hideMessage = !showMessage || isSmallDefault;
  var _renderMessaging = function _renderMessaging(messaging) {
    var messageContainerClassNames = classnames("".concat(CSS_BLOCK, "__message-box"), messageContainerProps === null || messageContainerProps === void 0 ? void 0 : messageContainerProps.className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__message-box--screen-reader-only"), hideMessage));
    var paragraphClassNames = classnames("".concat(CSS_BLOCK, "__message"), messageProps === null || messageProps === void 0 ? void 0 : messageProps.className);
    return /*#__PURE__*/_react.default.createElement("div", (0, _assign.default)({}, messageContainerProps, {
      className: messageContainerClassNames
    }), /*#__PURE__*/_react.default.createElement("p", (0, _assign.default)({}, messageProps, {
      className: paragraphClassNames,
      id: "".concat(uniqueId, "-message")
    }), messaging));
  };
  if (!visible) {
    return null;
  }
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__mask"), !isInline && !isBlock), "".concat(CSS_BLOCK, "__mask--full-screen"), isFullScreen), "".concat(CSS_BLOCK, "--inline"), isInline), "".concat(CSS_BLOCK, "--block"), isBlock), "".concat(CSS_BLOCK, "--sm"), size === 'sm' && !isFullScreen), "".concat(CSS_BLOCK, "--lg"), size === 'lg'));
  var boxClassNames = classnames("".concat(CSS_BLOCK, "__box"), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__box--inline"), isInline), "".concat(CSS_BLOCK, "__box--centered"), !isInline && !isBlock), "".concat(CSS_BLOCK, "__box--full-page"), type === 'fullPage'), boxProps === null || boxProps === void 0 ? void 0 : boxProps.className);
  var busyIndicator = /*#__PURE__*/_react.default.createElement("div", (0, _assign.default)({}, otherProps, {
    className: classes,
    ref: (0, _reactMergeRefs.default)([containerRef, _handleFocusManager, ref])
  }), customBody || ( /*#__PURE__*/_react.default.createElement("div", (0, _assign.default)({}, boxProps, {
    className: boxClassNames
  }), _renderBusyIndicator(), /*#__PURE__*/_react.default.createElement("span", (0, _assign.default)({}, statusProps, {
    id: uniqueId,
    role: "status",
    "aria-describedby": isInline ? undefined : "".concat(uniqueId, "-message"),
    "aria-label": isInline ? message : undefined,
    "aria-live": isFullScreen ? 'assertive' : 'polite',
    className: classnames("".concat(CSS_BLOCK, "__status"), statusProps === null || statusProps === void 0 ? void 0 : statusProps.className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__message-box--screen-reader-only"), !announcedMessage || hideMessage))
  }), announcedMessage && _renderMessaging(announcedMessage)), !announcedMessage && _renderMessaging(message))));
  return isFullScreen && isMounted ? /*#__PURE__*/_reactDom.default.createPortal(busyIndicator, document.body, 'busy-indicator-portal') : busyIndicator;
});
BusyIndicator.displayName = 'BusyIndicator';
var _default = exports.default = BusyIndicator;